<template>
  <div>
    <!-- <sidebar> -->
    <div class="sidebar" id="sidebar">
      <div class="sidebar-inner" id="style-15">
        <vue-custom-scrollbar
          class="scroll-area"
          :settings="settings"
          @ps-scroll-x="scrollHanle"
        >
          <div id="sidebar-menu" class="sidebar-menu">
            <ul>
              <li class="menu-title">
                <span>Main</span>
              </li>
              <li>
                <router-link to="/index" class="admin"
                  ><i class="la la-dashboard"></i>
                  <span> Dashboard</span></router-link
                >
              </li>

              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <span>Recruitment</span>
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/job-profile"
                  ><i class="la la la-briefcase"></i>
                  <span>Job Profile</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/vacancies"
                  ><i class="la la la-search"></i>
                  <span>Vacancies</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/applications"
                  ><i class="la la-cube"></i>
                  <span>Applications</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/applicants"
                  ><i class="la la-user-plus"></i>
                  <span>Applicants</span></router-link
                >
              </li>
              <!-- <li class="policies">
                <router-link to="/talent-search"
                  ><i class="la la-user-secret"></i>
                  <span>Talent Search</span></router-link
                >
              </li> -->
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/onboarding"
                  ><i class="la la-bullhorn"></i>
                  <span>Onboarding</span></router-link
                >
              </li>

              <!-- <li class="policies">
                <router-link to="/timesheet"
                  ><i class="la la la-user"></i>
                  <span>Timesheets</span></router-link
                >
              </li> -->
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <span>Organization</span>
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/companydepartments">
                  <i class="la la-file-pdf-o"></i>
                  <span>Departments</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/companydesignations">
                  <i class="la la-file-pdf-o"></i>
                  <span>Designations</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/companyunits">
                  <i class="la la-file-pdf-o"></i>
                  <span>Company Units</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/departmentunits">
                  <i class="la la-file-pdf-o"></i>
                  <span>Department Units</span></router-link
                >
              </li>

              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR')
                "
              >
                <router-link to="/designationroles">
                  <i class="la la-file-pdf-o"></i>
                  <span>Designation Roles</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM') ||
                    currentUser.roles.includes('HCPM')
                "
              >
                <span>Employees</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM') ||
                    currentUser.roles.includes('HCPM')
                "
              >
                <a href="#"
                  ><i class="la la-user"></i> <span> Employees </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="policies">
                    <router-link to="/employees">
                      <span>Employees</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/managers">
                      <span>Admin. Managers</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/optmanagers">
                      <span>Operational Managers</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/birthdays">
                      <span>Upcoming Birthday</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HODR')
                    "
                  >
                    <router-link to="/probatedemployees">
                      <span>Probated Employees</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HODR')
                    "
                  >
                    <router-link to="/probatedEmployeeExtension">
                      <span>Probation Extension</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HODR') ||
                        currentUser.roles.includes('HCPM')
                    "
                  >
                    <router-link to="/employeeTransfer">
                      <span>Employee Transfer</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="currentUser.roles.includes('HRAdmin')"
                  >
                    <router-link to="/leaves-current-month">
                      <span>Leave</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="currentUser.roles.includes('HRAdmin')"
                  >
                    <router-link to="/leaves">
                      <span>Leaves Record</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="currentUser.roles.includes('HRAdmin')"
                  >
                    <router-link to="/amendleaves">
                      <span>Amend Leave</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HODR')
                    "
                  >
                    <router-link to="/attendance">
                      <span>Attendants</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HCRM') ||
                        currentUser.roles.includes('TCRM')
                    "
                  >
                    <router-link to="/hr-current-loan-request">
                      <span>Loan Request</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HCRM') ||
                        currentUser.roles.includes('TCRM')
                    "
                  >
                    <router-link to="/manual-loan">
                      <span>Manual Loan</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HCRM') ||
                        currentUser.roles.includes('TCRM')
                    "
                  >
                    <router-link to="/hr-loan-request">
                      <span>Loan Records</span></router-link
                    >
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HODR')
                    "
                  >
                    <router-link to="/ranks"> <span>Ranks</span></router-link>
                  </li>
                </ul>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <a href="#"
                  ><i class="la la-money"></i> <span> Discipline </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="policies">
                    <router-link to="/disciplinary-case" class="salary">
                      Disciplinary Case
                    </router-link>
                  </li>
                  <!-- <li class="policies">
                    <router-link to="/query" class="salary">
                      Query
                    </router-link>
                  </li> -->
                  <li class="policies">
                    <router-link
                      to="/disciplinary-measures"
                      class="payrollitems"
                    >
                      <span>Disciplinary Measure</span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <span>Casual Workers</span>
              </li>
              <li
                class="policies"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <router-link to="/workers"
                  ><i class="la la-user"></i> <span>Workers</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <span>HR</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <a href="#"
                  ><i class="la la-money"></i> <span> Payroll </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li>
                    <router-link to="/salary-element" class="salary">
                      Salary Element
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/salary-sub-category" class="salary">
                      Salary Categories
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/salary-group" class="salary">
                      Salary Groups
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/salary-employee" class="salary">
                      Employee Salary
                    </router-link>
                  </li>
                  <li
                    class="policies"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HCRM') ||
                        currentUser.roles.includes('TCRM')
                    "
                  >
                    <router-link to="/manual-salary">
                      <span>Manual Salary</span></router-link
                    >
                  </li>
                  <li>
                    <router-link to="/payslip" class="payrollitems">
                      Payslip
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/reocurring-payslip" class="payrollitems">
                      Reocurring Payslip
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/prorated-salaries" class="salary">
                      Prorated Salaries
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="policies" v-if="currentUser.roles.includes('HRAdmin')">
                <router-link to="/policies"
                  ><i class="la la-file-pdf-o"></i>
                  <span>Policies</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.roles.includes('HRAdmin')">
                <router-link to="/holidays"
                  ><i class="la la-file-pdf-o"></i>
                  <span>Holidays</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HCPM') ||
                    currentUser.roles.includes('TLPM')
                "
              >
                <span>Performance</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HCPM') ||
                    currentUser.roles.includes('TLPM')
                "
              >
                <a href="#"
                  ><i class="la la-graduation-cap"></i>
                  <span> Performance </span> <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <!-- <li>
                    <router-link to="/performance-goals" class="performance">
                      Goals
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/performance-journals" class="performance">
                      Journals
                    </router-link>
                  </li> -->
                  <li>
                    <router-link to="/hr-review" class="performance">
                      Reviews
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/review-period" class="performance">
                      Review Period
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/key-performance-indicator"
                      class="performance"
                    >
                      Key Performance Indicator
                    </router-link>
                  </li>
                </ul>
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HTD') ||
                    currentUser.roles.includes('TLTD')
                "
              >
                <span>Training</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HTD') ||
                    currentUser.roles.includes('TLTD')
                "
              >
                <a href="#"
                  ><i class="la la-file-pdf-o"></i> <span> Training </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="policies">
                    <router-link to="/confirmed-training-needs">
                      <span>Training Needs</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/training-plan">
                      <span>Training Plan</span></router-link
                    >
                  </li>
                  <!-- <li class="policies">
                <router-link to="/group-training-plan"
                  >
                  <span>Group Training Plan</span></router-link
                >
              </li> -->
                  <li class="policies">
                    <router-link to="/training-program">
                      <span>Training Program</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/training-provider">
                      <span>Training Providers</span></router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="menu-title">
                <span>Self Center</span>
              </li>
              <li class="submenu">
                <a href="#"
                  ><i class="la la-graduation-cap"></i>
                  <span> My Self Center </span> <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li>
                    <router-link to="/resignationEmployeeHR">
                      <span>My Resignation Request</span></router-link
                    >
                  </li>
                  <li>
                    <router-link to="/retirementEmployeeHR">
                      <span>My Retirement Request</span></router-link
                    >
                  </li>
                  <li>
                    <router-link to="/team-performance-goals-hr">
                      <span>My Team Goals</span></router-link
                    >
                  </li>

                  <li>
                    <router-link to="/training-needs-hr">
                      <span>My Training Needs</span></router-link
                    >
                  </li>
                  <li>
                    <router-link to="/team-training-needs-hr">
                      <span>My Team Training Needs</span></router-link
                    >
                  </li>

                  <li class="policies">
                    <router-link to="/loan-request-hr">
                      <span>My Loan Request</span></router-link
                    >
                  </li>

                  <li class="policies">
                    <router-link to="/cash-advance-hr">
                      <span>My Cash Advance</span></router-link
                    >
                  </li>

                  <li class="policies">
                    <router-link to="/expense-claims-hr">
                      <span>My Expense Claim</span></router-link
                    >
                  </li>

                  <li class="policies">
                    <router-link to="/leave-request-hr">
                      <span>My Leave Request</span></router-link
                    >
                  </li>

                  <li class="policies">
                    <router-link to="/payslip-hr">
                      <span>My Salary</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/my-performance-goals-hr">
                      <span>My Goals</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/attendance-employee-hr">
                      <span>My Attendance</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/leavesByManager-hr">
                      <span>My Team Leaves</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/team-loan-request-hr">
                      <span>My Team Loans</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/manager-review-hr">
                      <span>My Team Reviews</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/expense-claims-manager-hr">
                      <span> My Team Expense</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/store-requisition-manager-hr">
                      <span>My Team Store Req</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/purchase-requisition-manager-hr">
                      <span>My Team Purchase Req</span></router-link
                    >
                  </li>
                </ul>
              </li>

              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <span>Promotion</span>
              </li>
              <li
                class="promotion"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <router-link to="/promotion"
                  ><i class="la la-bullhorn"></i>
                  <span>Promotion</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <span>Expense Management</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <a href="#"
                  ><i class="la la-ticket"></i> <span> Expense </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="resignation">
                    <router-link to="/expense-claims">
                      <span>Expense Claims</span></router-link
                    >
                  </li>
                  <li class="resignation">
                    <router-link to="/cash-advance">
                      <span>Cash Advance</span></router-link
                    >
                  </li>
                  <li class="resignation">
                    <router-link to="/cash-retirement">
                      <span>Cash Retirement</span></router-link
                    >
                  </li>
                  <li class="resignation">
                    <router-link to="/completed-expense-claims">
                      <span>Completed Expense Claims</span></router-link
                    >
                  </li>
                  <li class="resignation">
                    <router-link to="/completed-cash-advance">
                      <span>Completed Cash Advance</span></router-link
                    >
                  </li>
                </ul>
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <span>Exit Management</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <a href="#"
                  ><i class="la la-external-link-square"></i>
                  <span> Exit </span> <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="resignation">
                    <router-link to="/resignation">
                      <span>Resignation</span></router-link
                    >
                  </li>
                  <li class="termination">
                    <router-link to="/termination">
                      <span>Termination</span></router-link
                    >
                  </li>
                  <li class="retirement">
                    <router-link to="/retirement">
                      <span>Retirement</span></router-link
                    >
                  </li>
                  <li class="termination">
                    <router-link to="/exit"> <span>Exit</span></router-link>
                  </li>
                </ul>
              </li>

              <li class="menu-title">
                <span>Settings</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR') ||
                    currentUser.roles.includes('HODR') ||
                    currentUser.roles.includes('HCRM') ||
                    currentUser.roles.includes('TCRM')
                "
              >
                <a href="#"
                  ><i class="la la-cog"></i> <span> System Settings </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li
                    class="promotion"
                    v-if="currentUser.roles.includes('HRAdmin')"
                  >
                    <router-link to="/accountsettings">
                      <span>Account</span></router-link
                    >
                  </li>
                  <li
                    class="leavesettings"
                    v-if="currentUser.roles.includes('HRAdmin')"
                  >
                    <router-link to="/leavesettings">
                      <span>Leave</span></router-link
                    >
                  </li>
                  <li
                    class="termination"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HODR') ||
                        currentUser.roles.includes('TCRM')
                    "
                  >
                    <router-link to="/termination-type">
                      <span>Termination Type</span></router-link
                    >
                  </li>
                  <li
                    class="expense"
                    v-if="currentUser.roles.includes('HRAdmin')"
                  >
                    <router-link to="/expense-type">
                      <span>Expense Type</span></router-link
                    >
                  </li>
                  <li
                    class="expense"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HCRM')
                    "
                  >
                    <router-link to="/loan-type">
                      <span>Loan Type</span></router-link
                    >
                  </li>
                  <li
                    class="expense"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('HCRM')
                    "
                  >
                    <router-link to="/carloansetting">
                      <span>Car Loan Setting</span></router-link
                    >
                  </li>
                  <li
                    class="activity"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('TLMPR')
                    "
                  >
                    <router-link to="/activities">
                      <span>Activity</span></router-link
                    >
                  </li>
                  <li
                    class="resource"
                    v-if="
                      currentUser.roles.includes('HRAdmin') ||
                        currentUser.roles.includes('TLMPR')
                    "
                  >
                    <router-link to="/resources">
                      <span>Resource</span></router-link
                    >
                  </li>
                </ul>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('TLMPR')
                "
              >
                <a href="#"
                  ><i class="la la-cog"></i> <span> Skill Settings </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="promotion">
                    <router-link to="/skill"> <span>Skills</span></router-link>
                  </li>
                  <li class="resignation">
                    <router-link to="/skill-type">
                      <span>Skill Types</span></router-link
                    >
                  </li>
                  <li class="termination">
                    <router-link to="/skill-grade">
                      <span>Skill Grades</span></router-link
                    >
                  </li>
                  <li class="termination">
                    <router-link to="/skill-gap">
                      <span>Skill Gap</span></router-link
                    >
                  </li>
                </ul>
              </li>

              <li
                class="submenu"
                v-if="
                  currentUser.roles.includes('HRAdmin') ||
                    currentUser.roles.includes('HTD') ||
                    currentUser.roles.includes('TLTD')
                "
              >
                <a href="#"
                  ><i class="la la-cog"></i>
                  <span> Performance Settings </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <!-- <li>
                    <router-link to="/activity-status" class="performance">
                      Activity Status
                    </router-link>
                  </li> -->
                  <li>
                    <router-link to="/field-set" class="performance">
                      Fieldset
                    </router-link>
                  </li>
                  <!-- <li>
                    <router-link to="/activity-type" class="performance">
                      Activity Type
                    </router-link>
                  </li> -->
                  <li>
                    <router-link to="/activity-category" class="performance">
                      Goal Category
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/questions" class="performance">
                      Questions
                    </router-link>
                  </li>
                  
                </ul>
              </li>
            </ul>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <!-- </sidebar> -->
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    vueCustomScrollbar
  },
  mounted() {
    $("#sidebar-menu a").on("click", function(e) {
      if (
        $(this)
          .parent()
          .hasClass("submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("#sidebar-menu ul li.submenu a.active")
      .parents("li:last")
      .children("a:first")
      .addClass("active")
      .trigger("click");
  },
  computed: {
    currentpage() {
      return this.$route.path;
    }
  },
  data() {
    return {
      currentUser: authenticationService.currentUserValue,
      settings: {
        suppressScrollX: false
      },
      activeClass: "active"
    };
    //  isactive : true
  },
  methods: {
    scrollHanle(evt) {
      // console.log(evt);
    }
  }
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
/* .ps__rail-y {
        top: 0px !important;
    height: 657px !important;
    right: -3px !important;
    background-color: transparent !important;
        } */
</style>



// WEBPACK FOOTER //
// src/components/layouts/Sidebar.vue